import { render, staticRenderFns } from "./plusIcon.vue?vue&type=template&id=1af88a72"
import script from "./plusIcon.vue?vue&type=script&lang=js"
export * from "./plusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports